import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';
import { UserEatWellService } from 'src/app/services/user-eat-well.service';

@Component({
  selector: 'app-weekly-report-chart-eat-well',
  templateUrl: './weekly-report-chart-eat-well.component.html',
  styleUrls: ['./weekly-report-chart-eat-well.component.scss']
})
export class WeeklyReportChartEatWellComponent {
  @Input() weeksData:any;

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    
    labels: [
    ],
    datasets: [
      {
        data: [  ],
        label: 'Fruit and Veg',
      
      },{
        data: [  ],
        label: 'Protein',
      
      },{
        data: [  ],
        label: 'Fat',
     
      },{
        data: [  ],
        label: 'Carbs',
      
      },{
        data: [  ],
        label: 'Hydration',
      
      }
    ]
  };
  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    plugins:{
      legend:{
        position:'bottom'
      }
    },
    scales:{
      y:{
        stacked:true,
        display: true,
        position: 'left',
        suggestedMax: 35,
        suggestedMin: 0,
        beginAtZero:true,
        title: {
          display: true,
          text: "DAYS HIT TARGET",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      },
      x:{
        stacked:true,
        display: true,
        title: {
          display: true,
          text: "WEEK NUMBER",
          font: {
            size: 12,
            family: "Poppins",
            weight:"bold"
          },
        },
        ticks: {
          font: {
            size: 12,
            family: "Poppins",
          },
        },
        grid: {
          display:false
        }
      }
    },
  };
  public barChartLegend = true;


  constructor(private userEatWellService:UserEatWellService) {}

  ngOnInit(): void {
    this.setChartData();

  }

  setChartData() {
    
    this.barChartData.datasets[0].data = [];
    this.barChartData.labels = [];
   
    // setup chart data
    this.weeksData.slice().reverse().forEach((weekData:any, weekNo:number) => {
      //console.log(weekData[0].date);
      this.barChartData.labels?.push(
        weekNo+1
      );
       var stats = this.userEatWellService.getStats(weekData);
      this.barChartData.datasets[0].data.push(stats.daysHit.fruit_veg);
      this.barChartData.datasets[1].data.push(stats.daysHit.protein);
      this.barChartData.datasets[2].data.push(stats.daysHit.fat);
      this.barChartData.datasets[3].data.push(stats.daysHit.carbs);
      this.barChartData.datasets[4].data.push(stats.daysHit.hydration);
    });
  }


}
